import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig from "../../system/SystemConfig";
import IUIMessages from "../messages/IUIMessages";
import Wallet from "../../wallet/Wallet";
import IGame from "../../game/IGame";
import AbstractAudio from "../../engine/AbstractAudio";
import DesktopDOM from "../desktop/DesktopDOM";
import {ELEMENT_IDS} from "../desktop/DesktopDOM";

@injectable()
class VLT2DOM extends DesktopDOM {

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.UIMessages) uiMessages: IUIMessages,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.Game) game: IGame,
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: AbstractAudio

    ) {
        super(config, uiMessages, wallet, game);
    }

    createDOM() {
        super.createDOM();
        this.wrapper.classList.add("platform-vlt");

        if(this.config.platform.getDisplaysCount() == 2) {
            this.wrapper.classList.add("displays-count-2");
            $(".burger-menu-info").remove();
        }
    }

    init() {
        super.init();

        $('#'+ELEMENT_IDS.BUTTON_FULLSCREEN).hide();
        $('#'+ELEMENT_IDS.BUTTON_PARAGRAPH).hide();
        $('#'+ELEMENT_IDS.BUTTON_HISTORY).hide()
        if (this.config.platform.getDisplaysCount() > 1) {
            $('#'+ELEMENT_IDS.BUTTON_INFO).hide();
        }
    }
}

export default VLT2DOM;